import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cc-content-area',
  templateUrl: './content-area.component.html',
  styleUrls: ['./content-area.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentAreaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
